import { GetterTree } from 'vuex'
import { customFieldDividersToFiltersets } from './custom-field-dividers.helpers'
import { CustomFieldDividerState } from './custom-field-dividers.types'

export const getters: GetterTree<CustomFieldDividerState, unknown> = {
  customFieldDividers(state) {
    return state.customFieldDividers
  },
  dividersByLocation: state => (location: 'Products' | 'Components' | 'Variants') => {
    return state.customFieldDividers[location]
  },
  productDividersAsTreeNodes(_state, getters) {
    const productDividers = getters.dividersByLocation('Products')
    return customFieldDividersToFiltersets(productDividers)
  }
}
